require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-the-results-behind-the-rise-in-code-schools.json") })
        }
      }, "path---blog-the-results-behind-the-rise-in-code-schools");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-the-results-behind-the-rise-in-code-schools!./.cache/json/blog-the-results-behind-the-rise-in-code-schools.json
// module id = 1101
// module chunks = 231608221292675